// eslint-disable-next-line import/prefer-default-export
export const requireMailchimpConnectionState = (store, targetState, redirectTo) => (nextState, replace, callback) => {
  const state = store.getState();
  const mailchimpConnectionState = state.mailchimp.mailchimpConnectionState;

  if (mailchimpConnectionState === targetState) {
    replace({
      pathname: `${redirectTo}/${targetState}`,
      state: { nextPathname: nextState.location.pathname },
    });
  }

  return callback();
};
